import { convertBase64ToBlob } from 'services/Utils';

export const b64toFile = (b64Data: string, contentType: string, filename: string): File => {
  const blob = convertBase64ToBlob(b64Data, contentType);
  return new File([blob], filename, { type: contentType });
};

export const canGenerateVideo = () => 'MediaRecorder' in window && 'MediaStream' in window;

const pad = (n: number) => n.toString().padStart(2, '0');

export const formatDuration = (elapsedMs: number): string => {
  const totalSeconds = Math.trunc(elapsedMs / 1000);
  const ss = totalSeconds % 60;
  const mm = Math.trunc(totalSeconds / 60) % 60;
  const hh = Math.trunc(totalSeconds / 3600);
  return `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
};
